var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.108 16.82L.59 15.518 6.683 8.41.59 1.302 2.108 0l6.651 7.76a1 1 0 010 1.301L2.108 16.82z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuMTA3OTcgMTYuODJMMC41ODk5NjYgMTUuNTE4TDYuNjgyOTcgOC40MUwwLjU4OTk2NiAxLjMwMkwyLjEwNzk3IDBMOC43NTg5NyA3Ljc2QzkuMDc5OTcgOC4xMzQgOS4wNzk5NyA4LjY4NyA4Ljc1ODk3IDkuMDYxTDIuMTA3OTcgMTYuODJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgArrowRight as ReactComponent };